import axios from 'axios';

// ===========================================
// API Base URLs - Zentrale Konfiguration
// ===========================================
// Bei Wechsel der Backend-Technologie nur hier anpassen
export const API_BASE_URL = 'https://eisenbahn.wingen.de/api';
export const NEWS_BASE_URL = 'https://eisenbahn.wingen.de/news';

// ===========================================
// API Endpoints
// ===========================================
export const API_ENDPOINTS = {
    // Bildergalerie
    list: `${API_BASE_URL}/list`,
    count: `${API_BASE_URL}/count`,
    search: `${API_BASE_URL}/search`,
    single: `${API_BASE_URL}/single`,
    latest: `${API_BASE_URL}/latest`,
    imageNavigation: `${API_BASE_URL}/image-navigation`,

    // Filter
    filter: `${API_BASE_URL}/filter`,
    getFilter: `${API_BASE_URL}/get-filter`,
    popularFilters: `${API_BASE_URL}/popular-filters`,

    // Shop
    order: `${API_BASE_URL}/order`,
    shoppingProducts: `${API_BASE_URL}/shopping-products`,
    invoice: `${API_BASE_URL}/invoice`,

    // Bilder (Image Proxy)
    image: (imageId) => `${API_BASE_URL}/image/${imageId}`,

    // Sonstiges
    info: `${API_BASE_URL}/info`,
    createWebP: `${API_BASE_URL}/create-webp`,
    guestbook: `${API_BASE_URL}/guestbook`,

    // Gästebuch (Subdirectory - bereits REST-like)
    guestbookGetEntry: `${API_BASE_URL}/guestbook/getEntry`,
    guestbookSetEntry: (guid) => `${API_BASE_URL}/guestbook/setEntry/${guid}`,
    guestbookEditEntry: (id) => `${API_BASE_URL}/guestbook/editEntry/${id}`,
    guestbookDeleteEntry: (id) => `${API_BASE_URL}/guestbook/deleteEntry/${id}`,
    guestbookIsAdmin: `${API_BASE_URL}/guestbook/isAdmin`,

    // Cache (statische JSON-Dateien)
    cacheCategory: (category) => `${API_BASE_URL}/cache/category/${category}.json`,

    // User API (Subdirectory - bereits REST-like)
    user: `${API_BASE_URL}/user`,

    // News/WordPress API
    newsPage: `${NEWS_BASE_URL}/page`,
    newsMenu: `${NEWS_BASE_URL}/menu`,
    newsArticle: `${NEWS_BASE_URL}/article`,
    newsLatestArticles: `${NEWS_BASE_URL}/latest-articles`,
};

// ===========================================
// Axios Instance für User API
// ===========================================
export const api = axios.create({
    baseURL: `${API_BASE_URL}/user`,
    headers: { 'Content-Type': 'application/json' },
});

let getToken = null;
export function bindTokenGetter(fn) { getToken = fn; }

let onUnauthorized = null;
export function bindUnauthorizedHandler(fn) { onUnauthorized = fn; }

// Request-Interceptor: Token anhängen + Debug
api.interceptors.request.use((config) => {
    const token = getToken && getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        // console.debug('[api] attach Authorization', token.slice(0, 8) + '…');
    } else {
        // console.debug('[api] no token set');
    }
    return config;
});

// Response-Interceptor: Nur dann auto-logout, wenn wirklich ein Token mitgesendet wurde
api.interceptors.response.use(
    (res) => res,
    (err) => {
        const status = err?.response?.status;
        const hadAuth = !!err?.config?.headers?.Authorization;
        if (status === 401 && hadAuth && onUnauthorized) {
            onUnauthorized();
        }
        return Promise.reject(err);
    }
);
